import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/arrow-up-solid.svg'
import _imports_1 from '../assets/arrow-down-solid.svg'


const _hoisted_1 = { class: "topnavbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, "Brettchenweb-Tool", -1)
const _hoisted_3 = { class: "leftAlign" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { class: "topnav" }, "Exportieren", -1)
const _hoisted_5 = { class: "brettchenTable" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["test"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileReader = _resolveComponent("FileReader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("td", _hoisted_3, [
          _createVNode(_component_FileReader, { onLoad: _ctx.gotImage }, null, 8, ["onLoad"]),
          _hoisted_4
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewLine && _ctx.addNewLine(...args)))
          }, "Neue Reihe laden"),
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeLastLine && _ctx.removeLastLine(...args)))
          }, " Letzte Reihe löschen ")
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.usePreviousArrows()))
          }, " Vorherige Pfeile laden"),
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.useNextArrows()))
          }, " Nächste Pfeile laden ")
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.arrowsInvert && _ctx.arrowsInvert(...args)))
          }, "Pfeile invertieren"),
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.arrowsUp && _ctx.arrowsUp(...args)))
          }, "Pfeile nach oben")
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.console.log(1)))
          }, " Muster herunterladen"),
          _createElementVNode("button", {
            class: "topnav",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadArrows()))
          }, " Pfeile herunterladen ")
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseInt(_ctx.rowLength), (_, index) => {
          return (_openBlock(), _createElementBlock("td", {
            key: index,
            onClick: ($event: any) => (_ctx.toggleDirection(index))
          }, [
            (_ctx.toTurn[0][index] == 'up')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _imports_0,
                  alt: "↑",
                  test: index,
                  style: _normalizeStyle({ width: 50 / _ctx.rowLength + 'vw' })
                }, null, 12, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.toTurn[0][index] == 'down')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _imports_1,
                  alt: "↓",
                  style: _normalizeStyle({ width: 50 / _ctx.rowLength + 'vw' })
                }, null, 4))
              : _createCommentVNode("", true)
          ], 8, _hoisted_6))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.img, (row, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell_color, index_1) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index_1,
              style: _normalizeStyle({ height: 98 / row.length + 'vw' })
            }, [
              _createElementVNode("div", {
                class: "parallelogram",
                style: _normalizeStyle({
            background:
              'rgba(' +
              cell_color[0] +
              ',' +
              cell_color[1] +
              ',' +
              cell_color[2] +
              ',' +
              cell_color[3] +
              ')',
            transform: 'skew(' + (_ctx.tilt_dir[index_1] == 'S' ? -10 : 10) + 'deg)',
          })
              }, [
                _createElementVNode("span", {
                  style: _normalizeStyle({
              transform:
                'skew(' + (_ctx.tilt_dir[index_1] == 'S' ? 10 : -10) + 'deg)',
            })
                }, _toDisplayString(_ctx.currentState[index] != null ? _ctx.currentState[index][index_1] : ""), 5)
              ], 4)
            ], 4))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tilt_dir, (row, index) => {
          return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(row), 1))
        }), 128))
      ])
    ])
  ], 64))
}